export const marketPlaceImages = {
  market_banner: 'assets/img/bed-bath/Banner@3x.png',
  dollar_coin_svg: 'assets/img/Dollar-Coin.svg',
  location_pin_icon: 'assets/img/bed-bath/location-pin.svg',
  star_icon: 'assets/img/star.svg',
  map_icon: 'assets/img/map.svg',
  hammer_icon: 'assets/img/hammer.svg',
  close_icon: 'assets/img/close.svg',
  arrow_logout_icon: 'assets/img/pricing-icon/Arrows_logout.svg',
  youtube_icon: 'assets/img/pricing-icon/Brand_youtube.svg',
  three_d_icon: 'assets/img/pricing-icon/3d.svg',
  blueprint_icon: 'assets/img/pricing-icon/blueprint.svg',
  external_icon: 'assets/img/pricing-icon/External.svg',
  advertise_2: 'assets/img/bed-bath/advertise-2.png',
  advertise_3: 'assets/img/bed-bath/advertise-3.png',
  advertise_4: 'assets/img/bed-bath/advertise-4.png',
  market_1_icon: 'assets/menu-customisation-icons/MarketPlace/market1.svg',
  market_2_icon: 'assets/menu-customisation-icons/MarketPlace/market2.svg',
  market_3_icon: 'assets/menu-customisation-icons/MarketPlace/market3.svg',
  market_4_icon: 'assets/menu-customisation-icons/MarketPlace/market4.svg',
};
